import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Dropdown, Input, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {toUpperCase} from '../../../common/util/fieldsNormalization';
import {parseWarehouses, parseFileData} from '../../utils';
import ExcelReader from '../../../excelReader/components/index';
import LocationAssignmentTable from './table';
import './assignment.scss';

class LocationsAssignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'location': '',
    };

    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleWarehouseChange = this.handleWarehouseChange.bind(this);
    this.handleFileLoad = this.handleFileLoad.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.LocationAssignment, scopes.Edit)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearLocationsAssignments();
    this.props.fetchWarehouses();
  }

  componentWillUnmount() {
    this.props.clearLocationsAssignments();
  }

  renderFieldsActions() {
    const {loadingFreeLocations, selectedWarehouse, assigning, pageNumber, pageSize, count} = this.props;
    const pagesCount = Math.ceil(count / pageSize);
    const lastPage = pagesCount === 0 ? 0 : pagesCount - 1;

    if (!loadingFreeLocations && !assigning && selectedWarehouse && pageNumber === lastPage) {
      return (
        <div className='fields-actions'>
          <a onClick={this.handleAddClick}>
            <strong>+ AGREGAR REGISTRO</strong>
          </a>
        </div>
      );
    }

    return null;
  }

  handleAddClick() {
    this.props.addLocationAssignment();
  }

  handleWarehouseChange(event, data) {
    const {selectedWarehouse} = this.props;
    const {location} = this.state;

    if (selectedWarehouse === data.value) {
      return;
    }

    this.props.getFreeWarehouseLocations(data.value);
    if (location) {
      this.props.changeWarehouseAllocationPage(0);
      this.handleSearch(0, data.value);
    }
  }

  handleFileLoad(data) {
    const {selectedWarehouse} = this.props;
    const loadedAssignments = parseFileData(data);
    this.props.loadingExcel(false);
    this.props.checkLocationsAssignment(selectedWarehouse, loadedAssignments);
  }

  handleSubmit(paramsForGetElementNextPage) {
    const isValid = this.checkLocationsAreValid();

    if (isValid) {
      const {selectedWarehouse, fields} = this.props;
      this.props.submitLocationsAssignment(selectedWarehouse, fields, paramsForGetElementNextPage);
    }
  }

  checkLocationsAreValid() {
    const {fields} = this.props;
    const newLocations = [];
    const repeatedLocations = [];

    fields.forEach((element) => {
      if (element.newLocation) {
        if (!newLocations.includes(element.newLocation)) {
          newLocations.push(element.newLocation);
        } else {
          repeatedLocations.push(element.newLocation);
        }
      }

      element.newReservedLocations.forEach((item) => {
        if (element.newLocation) {
          if (!newLocations.includes(item)) {
            newLocations.push(item);
          } else {
            repeatedLocations.push(item);
          }
        }
      });
    });

    if (!repeatedLocations.length) {
      return true;
    }

    this.props.addMessageBoxError(`La(s) siguiente(s) ubicaciones: ${repeatedLocations.join(', ')}, ` +
      'están siendo asignadas multiples veces. Verifique por favor.');
    return false;
  }

  handleSearch(offset = 0, warehouse) {
    const {pageSize} = this.props;
    const params = {
      'location': this.state.location,
      'limit': pageSize,
      'offset': offset,
    };
    this.props.getAssignmentsList(warehouse, params);
  }

  renderSubmitButton(selectedWarehouse) {
    const {fields, loadingFreeLocations, checkingFile, submittingAssignments, loadingAssignmentsList} = this.props;
    const submitStatus = !fields.length || loadingFreeLocations || checkingFile ||
      submittingAssignments || loadingAssignmentsList;

    if (selectedWarehouse) {
      return (
        <Button primary type='submit' onClick={this.handleSubmit.bind(this, {})} disabled={submitStatus}>
          Guardar
        </Button>
      );
    }
    
    return null;
  }

  renderImportButton(selectedWarehouse) {
    const {loadingFreeLocations, checkingFile, submittingAssignments, loadingPartInfo,
      loadingAssignmentsList} = this.props;
    const importStatus = loadingFreeLocations || checkingFile || submittingAssignments || loadingPartInfo ||
      loadingAssignmentsList;

    if (selectedWarehouse) {
      return (
        <ExcelReader onGetFile={this.handleFileLoad} text='Importar' saving={importStatus} />
      );
    }

    return null;
  }

  renderWarehouseSelector() {
    const {permissions, warehouses, loadingFreeLocations, selectedWarehouse,
      checkingFile, submittingAssignments, loadingPartInfo, loadingAssignmentsList} = this.props;
    const selectorStatus = loadingFreeLocations || checkingFile || submittingAssignments || loadingPartInfo ||
      loadingAssignmentsList;
    const filteredWarehouses = parseWarehouses(warehouses, permissions).map(
      (item) => ({'text': item.code, 'value': item.code})
    );

    return (
      <Dropdown
        selection
        options={filteredWarehouses}
        onChange={this.handleWarehouseChange}
        value={selectedWarehouse}
        disabled={selectorStatus}
      />
    );
  }

  renderLocationSection(selectedWarehouse) {
    const {loadingPartInfo, loadingAssignmentsList} = this.props;
    if (!selectedWarehouse) {
      return null;
    }

    return (
      <div className='location-section'>
        <h4>Ubicación</h4>
        <Input
          value={this.state.location}
          onChange={this.handleLocationChange.bind(this)}
          maxLength='12'
          disabled={loadingPartInfo || loadingAssignmentsList}
        />
        <Button primary className='search' type='submit' onClick={this.handleSearch.bind(this, 0, selectedWarehouse)}
          disabled={!this.state.location || loadingPartInfo || loadingAssignmentsList}>
          Buscar
        </Button>
      </div>
    );
  }

  handleLocationChange(event, target) {
    const {value} = target;
    this.setState({'location': toUpperCase(value)});
  }

  renderLoader(message = '') {
    return (
      <Card raised fluid>
        <Loader active inline='centered'>
          {message}
        </Loader>
      </Card>
    );
  }

  render() {
    const {loadingWarehouses, selectedWarehouse} = this.props;

    if (loadingWarehouses) {
      return this.renderLoader('Obteniendo Información...');
    }
    
    return (
      <div className='location-assignment'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Asignación/Cambio de Ubicación</h2>
              <div className='title-bar-actions'>
                {this.renderLocationSection(selectedWarehouse)}
                <h4>Bodega</h4>
                {this.renderWarehouseSelector()}
                {this.renderImportButton(selectedWarehouse)}
                {this.renderSubmitButton(selectedWarehouse)}
              </div>
            </div>
          </div>
        </Card>
        <LocationAssignmentTable handleSearch={this.handleSearch} handleSubmit={this.handleSubmit}/>
        {this.renderFieldsActions()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'assigning': state.locationsAssignment.assigning,
    'fields': state.locationsAssignment.assignments,
    'selectedWarehouse': state.locationsAssignment.warehouse,
    'loadingFreeLocations': state.locationsAssignment.loadingFreeLocations,
    'checkingFile': state.locationsAssignment.checkingAssignments,
    'loadingAssignmentsList': state.locationsAssignment.loadingAssignmentsList,
    'loadingPartInfo': state.locationsAssignment.loadingPartAssignment,
    'submittingAssignments': state.locationsAssignment.submittingAssignments,
    'loadingWarehouses': state.warehouses.loading,
    'warehouses': state.warehouses.list,
    'count': state.locationsAssignment.count,
    'pageNumber': state.locationsAssignment.offset,
    'pageSize': state.locationsAssignment.limit,
    'loadingExcel': state.excelReader.loading,
  };
};

const {
  getAssignmentsList,
  fetchWarehouses,
  clearLocationsAssignments,
  addLocationAssignment,
  getFreeWarehouseLocations,
  checkLocationsAssignment,
  submitLocationsAssignment,
  getWarehouseAllocations,
  changeWarehouseAllocationPage,
  addMessageBoxError,
  navigateTo,
  loadingExcel,
} = Actions;

export default connect(mapStateToProps, {
  getAssignmentsList,
  fetchWarehouses,
  clearLocationsAssignments,
  addLocationAssignment,
  getFreeWarehouseLocations,
  checkLocationsAssignment,
  submitLocationsAssignment,
  getWarehouseAllocations,
  changeWarehouseAllocationPage,
  addMessageBoxError,
  navigateTo,
  loadingExcel,
})(LocationsAssignment);
